import React from 'react';

const BorderDivision = () => <div className='border-division'></div>;

export default BorderDivision;